import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GENERIC_ERROR} from '../../constants/ErrorConstants';
import {DeleteLiveAlertCall} from '../../apis/live';
import {DeleteAlertMarketPayload} from '../../@types/actions';
import {DELETE_ALERT_SUCCESS} from '../../constants/LiveConstants';

function* tryFunction(payload: DeleteAlertMarketPayload) {
    yield call(DeleteLiveAlertCall, payload);
    yield put({
        type: DELETE_ALERT_SUCCESS,
        payload: payload
    });
}

export function* deleteAlertSaga({payload}: { payload: DeleteAlertMarketPayload }): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction, payload: payload},
        failedType: GENERIC_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}